import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx';

import { StorageService } from '../storage/storage.service';
declare var sunmiInnerPrinter: any;

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  uuid: string;
  printer: string;

  constructor(private bluetoothSerial: BluetoothSerial, private storageService: StorageService,
              public toastController: ToastController) {}

  pairedDevicesBT() {
    return this.bluetoothSerial.list();
  }

  print(data) {
    // get uuid & printer
    this.storageService.getObject('vendor-settings').then(value => {
      this.printer = value.printerInterface;
      this.uuid = value.printerID;

      // Select printer based on saved settings
      if (this.printer === 'BLUETOOTH') {
        this.printBT(data);
      } else if (this.printer === 'INNER') {
        this.printInner(data);
      }else if(this.printer === 'DESKTOP'){
        this.printDesktop(data);
        //this.formatDesktopPrint(data);
      }
       else {
        this.presentToast('No printer setup yet, please save your printer settings', 'danger');
      }
    });
  }

  printBT(data) {
    this.bluetoothSerial.isEnabled()
        .then((value) => {
          const BTconnection = this.bluetoothSerial.connect(this.uuid).subscribe(conn => {
            this.bluetoothSerial.write(data)
                .then(res => {
                  this.presentToast('Printing via Bluetooth Printer !', 'success');
                  BTconnection.unsubscribe();
                }, error => {
                  this.presentToast(error.toString(), 'danger');
                });
          }, err => {
            alert(err.toString());
          });
        })
        .catch(() => {
          this.presentToast('Bluetooth is disabled ! \n To use bluetooth please enable Bluetooth' +
                            ' or change printer in the settings', 'danger');
          this.bluetoothSerial.enable()
              .then(() => {
                this.presentToast('Bluetooth Enabled', 'success');
              }).catch(() => {
                this.presentToast('Can\'t Enable Bluetooth', 'danger');
              });
        });
  }

  printInner(data) {
    try {
      sunmiInnerPrinter.setFontSize(24);
      setTimeout(() => {
        // sunmiInnerPrinter.printTextWithFont(data, 'arial', 25);
        sunmiInnerPrinter.printOriginalText(data);
      }, 500);
      this.presentToast('Printing via Native Printer !', 'success');
    } catch (e) {
      console.log(e.toString());
      this.presentToast('Cannot print your receipt, native printer not found.', 'danger');
    }
  }

  printDesktop(data){
    debugger;
    /*
      Adapted from
      https://stackoverflow.com/questions/887340/can-you-add-parameters-inside-a-print-function-in-javascript
    
      The code below will open a new window and pass the data into it
    */
    let printingData = `<div align='center'><table><colgroup col span='2'></colgroup><tr><th>` + data + `</th></tr></table></div>`;
    let newWindow = window.open("","");
    newWindow.document.open();
   // newWindow.document.write('<'+'html'+'><'+'body'+'>');
    newWindow.document.write(printingData);
   // newWindow.document.write('</'+'body'+'></'+'html'+'>');
    newWindow.document.close();
    newWindow.print();
    newWindow.close();
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

  formatDesktopPrint(data){
     debugger;
    if(data.vendor !== undefined){
      this.formatPrintReceipt(data);
    }
    else{
      this.formatBatchReport(data);
    }
  }

  formatBatchReport(data){
    // debugger;
    let batchDataArray = data.split("\r\n");
    for (let index = 0; index < batchDataArray.length; index++) {
      const element = batchDataArray[index];
      if(element == ""){
        batchDataArray.splice(index,1);
      } 
    }

    let formattedBatchData = batchDataArray;

    for (let index = 0; index < formattedBatchData.length; index++) {
      const element = formattedBatchData[index];
      if(element == ""){
        formattedBatchData.splice(index,1)
      }
    }
    formattedBatchData.splice(11,1);
    formattedBatchData.splice(12,1);
    let furtherFormattedData = formattedBatchData;
    
    furtherFormattedData.splice(10,1)

    const batchrcpt = 
    `\r\n
    <h4>${ furtherFormattedData[0] }</h4>\r\n
    <br/>${ furtherFormattedData[1] }\r\n
    <br/>${ furtherFormattedData[2] + ":" + furtherFormattedData[3] }\r\n
    <br/>${ furtherFormattedData[4] + ":" + furtherFormattedData[5] }\r\n
    <br/>${ furtherFormattedData[6] + ":" + furtherFormattedData[7] }\r\n
    <br/>${ furtherFormattedData[8] + ":" + furtherFormattedData[9] }\r\n
    \r\n`;

    this.printDesktop(batchrcpt);
  }

  formatPrintReceipt(data){
    // debugger;
    let segmentOne = data.tokenDetails.STSTokens[0].STSToken.substr(0,4);
    let segmentTwo = data.tokenDetails.STSTokens[0].STSToken.substr(4,4);
    let segmentThree = data.tokenDetails.STSTokens[0].STSToken.substr(8,4);
    let segmentFour = data.tokenDetails.STSTokens[0].STSToken.substr(12,4);
    let segmentFive = data.tokenDetails.STSTokens[0].STSToken.substr(16,20);
    let token = segmentOne + ' ' + segmentTwo + ' ' + segmentThree + ' ' + segmentFour + ' ' + segmentFive;

    let vendor:string;
    if(data.vendor == null){
      vendor = ''
    }else{
      vendor = data.vendor
    }

    let vatregNo:number;
    if(data.customerInfo.utilityDetail.vatRegNo == null){
      vatregNo = 0
    }else{
      vatregNo = data.customerInfo.utilityDetail.vatRegNo
    }

    let customer:string;
    if(data.customerInfo.customerDetail.name == null){
      customer = ''
    }else{
      customer = data.customerInfo.customerDetail.name
    }

    let address:string;
    if(data.customerInfo.customerDetail.address == null){
      address = ''
    }else{
      address = data.customerInfo.customerDetail.address
    }

     const rcpt = 
    `\r\n<h4>Tax Invoice (Reprint)\r\nVendor: ${ vendor } \r\n\r\n${ address }</h4>\r\n
    <br/>VatRegNo: ${ vatregNo }\r\n
    <br/>Receipt No: ${data.receiptNumber}\r\n
    <br/>Date:  ${ data.customerInfo.customerDetail.lastPurchased }\r\n
    <br/>Customer: ${ customer }\r\n
    <br/>Address: ${ address }\r\n
    <br/>Meter No: ${ data.customerInfo.meterDetail.serialNo }\r\n
    <br/>TI: ${ data.customerInfo.meterDetail.tariffIndex }\r\n
    <br/>SGC: ${ data.customerInfo.meterDetail.supplyGroup }\r\n
    <br/>KRN: ${ data.customerInfo.meterDetail.krn }\r\n
    <br/>Tendered: ${ data.utilityAmount }\r\n
    <br/>Tariff Charge: ${ data.transactions[1].amount }\r\n
    <br/>Service Charge: ${ data.transactions[0].amount }\r\n
    <br/>VAT:  ${data.vat}\r\n
    <br/>Units: ${ data.transactions[0].units }\r\n
    <br/>Tariff: ${ data.transactions[1].description }\r\n
    <br/>Token: \n<b>${ token }</b>\r\n\r\n\r\n
    <br/><br/><i><u>netVend  0811440482 
    \r\nNEF and ECB levy \r\nincl. in tarrif</u></i>\r\n\r\n\r\n\r\n\r\n\r\n\r\n`;

    this.printDesktop(rcpt);
  }
}
